import React, { useContext } from 'react'
import CloseIcon from '../../assets/close-preview-icon.svg'
import CustomImage from '../../components/customImage/customImage'
import { getVideoThumbnail } from '../../utils/helper'
import { AppContext } from '../../context/app'

const ProgramPreview = ({ selectedPreviewProgram, setSelectedPreviewProgram }) => {
  const { accountObj } = useContext(AppContext)
  return (
    <div className="absolute top-0 right-0 z-30 w-[280px] h-[246px] rounded-lg bg-white pointer-events-auto overflow-hidden preview-slider-animation">
      <div className="w-full h-[158px] relative">
        <img
          src={CloseIcon}
          alt="CloseIcon"
          style={{ width: '17.7px', height: '17.7px' }}
          className="m-2 absolute top-0 left-0 z-10 cursor-pointer"
          onClick={() => setSelectedPreviewProgram({})}
        />
        <CustomImage
          imageUrl={getVideoThumbnail(accountObj?.cf_domain_name, selectedPreviewProgram?.asset_id)}
          alt="ContentImage"
          imgClass="w-full h-full"
          loaderClass="w-full h-full"
        />
      </div>
      <div style={{ padding: '6px 14px' }} className="w-full h-[calc(100%-158px)]">
        <p
          style={{ color: '#05498d', overflowWrap: 'break-word' }}
          className="font-semibold text-sm line-clamp-2"
        >
          {selectedPreviewProgram?.title || ''}
        </p>
        <p
          style={{ color: '#909090', overflowWrap: 'break-word' }}
          className="mt-[6px]  text-[11px] line-clamp-2"
        >
          {selectedPreviewProgram?.description || ''}
        </p>
      </div>
    </div>
  )
}

export default ProgramPreview
